import React from "react";
import logo from "assets/img/logo/logo_aig_login-2.png";
import {
  Card,
  CardBody,
  Row,
  Col,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  Alert,
  ModalFooter,
} from "reactstrap";
import { Growl } from "primereact/growl";
import { Textbox, Checkbox } from "react-inputs-validation";
import "../../styles/estilos.css";
import Select1 from 'react-select';
import { withRouter } from "react-router-dom";
import publicIp from "public-ip";
import { connect } from "react-redux";
import makeAnimated from "react-select/lib/animated";
import {
  consultarCedulaFetch,
  setConsultaPlaca,
  setDatosPersona,
  coberturasFetch,
  AmparosAdicionalesFetch,
  FetchDescargarCotizacionAbierto,
} from "../../redux/actions/aCotizacion";
import LoadingScreen from "react-loading-screen";
import {
  FetchModificarCarrito,
  FetchGuardarDatosAdiconalesCarrito,
  FetchTotalesCabeceraCotizadores,
} from "../../redux/actions/ACarritoProductos";
import "react-inputs-validation/lib/react-inputs-validation.min.css";
import "react-datepicker/dist/react-datepicker.css";

import { ambienteAplicacion, urlGenerarPago, urlGetRecompraConfirmacion, urlGuardarRenovaciones } from "../../constants/urls";
import ValoresRecompra from "../Cotizacion/ValoresRecompra";
import { FetchDataRecompraPaquete } from "../../redux/actions/APolizas";
import { apiGet, apiPost2 } from "../../api";
import { tramaSuscripcionTarjetaP2P } from "../../constants/tramas/tramasPago";
import { suscripcionExternaTarjetaP2P } from "../../redux/actions/aPagos";
import { consultarUsuarioFV } from "../../redux/actions/aFormularioVinculacion";
import NumberFormat from 'react-number-format';
import ValoresRenovacion from "../Cotizacion/ValoresRenovacion";
import { formatearNumero, FetchListadoRenovaciones } from "../../redux/actions/aLogin";

class Renovacion extends React.Component {
  constructor(props) {
    super(props);

    const { datosRecompra, datosRenovaciones } = this.props;

    console.log('mis props: ', this.props.datosRenovaciones)
    this.state = {
      placa: datosRenovaciones.placa,
      dataRenovacion: null,
      allDataRenovacion: null,
      validate: false,
      hasPlacaError: true,
      rastreo: false,
      territorioSeleccionado: "1",
      formEditado: false,
      isLoading: false,
      sumaAseguradaHasError: false,
      valorAsegurado: this.props.datosRenovaciones && this.props.datosRenovaciones.renovacionSeleccionada && datosRenovaciones.renovacionSeleccionada.dataTransformada ? datosRenovaciones.renovacionSeleccionada.dataTransformada.total : null,
      arrayTerritorios: [],
      arrayAccesorios: [],
      arrayColores: [],
      cedulaError: "",
      hasColorError: false,
      hasMotorError: true,
      hasChasisError: true,
      arrayTipos: [],
      tipoSeleccionado: null,
      hasTipoError: false,
      contadorCoberturas: 0,
      amparoGastosMedicosCheked: true,
      amparoAccidentesPersonalesCheked: true,
      amparoAutoSustitutoCheked: true,
      amparoLlaveProtegidaCheked: true,
      amparoDocumentosProtegidosCheked: true,
      hasCapacidadError: true,
      deducibleSelected: null,
      arrayRc: [],
      rcSelected: null,
      verDeducibles: false,
      verRc: false,
      mostrarMensajeValidarEdad: false,

      codigoProductoEspecial: null,
      planes: [],
      planSeleccionado: null,
      utilizarMismaTarjeta: false,
      cuotas: 1,
      cuotaSeleccionada: {
        value: 1,
        label: '1 mes (Pago corriente)'
      },
      bancoSeleccionado: listSlct1(this.props.datosBancos)[0],
      arrayCuotas: [],
      openModal: false,
      datosPagador: null,
      idPoliza: null,
      idCarrito: null,
      completo: false,
      selectedOption: null,
      email: '',
      tieneError: false,
      mensajeError: '',
      errorSumaAsegurada: '',
    };
    this.validateForm = this.validateForm.bind(this);


  }

  async componentDidMount() {
    window.scrollTo(0, 0);





    let arrayAccesorios = [];

    if (this.props.catalogoCotizacion && this.props.catalogoCotizacion.accesorios && Array.isArray(this.props.catalogoCotizacion.accesorios)) {

      this.props.catalogoCotizacion.accesorios.forEach((element) => {
        const elemento = {
          value: element.accCodigoCore,
          label: element.accNombre,
        };
        arrayAccesorios.push(elemento);
      });


    }



    this.setState({ arrayAccesorios: arrayAccesorios });

    await this.props.listadoDeRenovaciones(this.props.datosUsuario.brokerCodigo, ambienteAplicacion, this.props.idPoliza, null, null)

    console.log('renovaciones222', this.props.datosRenovaciones)

    this.setState({

      dataRenovacion: this.props.datosRenovaciones && this.props.datosRenovaciones.renovacionSeleccionada ? this.props.datosRenovaciones.renovacionSeleccionada.dataTransformada : null,
      allDataRenovacion: this.props.datosRenovaciones && this.props.datosRenovaciones.renovacionSeleccionada ? this.props.datosRenovaciones.renovacionSeleccionada.alldata : null,

    })



  }
  /**
   * 
   * @param {*} valor Valor seleccionado en el dropdown bancos
   * Acción al seleccionar un banco
   */
  handleChangeBanco = (valor) => {
    const { datosBancos } = this.props;
    const diferidos = datosBancos.find(banco => banco.id == valor.value).cuotas

    this.setState({
      bancoSeleccionado: valor,
      cuotaSeleccionada: this.listSlct1Cuotas(diferidos, this.state.planSeleccionado)[0],
      cuotas: 1,
      codigoBanco: valor.value,
      arrayCuotas: this.listSlct1Cuotas(diferidos, this.state.planSeleccionado),
    })
  }



  async onEnviar(event, email, url, idCarrito) {



    if (email != "") {
      event.preventDefault()
      let datosJson = {
        empresa: "AIGMETROPOLITANA",
        plataforma: "WEB",
        accion: "enviar",
        correo: email,
        idCarrito: idCarrito,
        url: url
      }

      await this.props.descargarCotizacion(datosJson)
    }



  }


  /**
   * 
   * @param {*} valor valor seleccionado en el dropdown cuotas
   * Acción al seleccionar un elemento en el dropdown de cuptas
   */
  handleChangeCuotas = (valor) => {
    this.setState({
      cuotaSeleccionada: valor,
      cuotas: parseInt(valor.value),
    })
  }

  openModal = (value) => {
    this.setState({ openModal: value });
  };
  suscripcion = (datosPagador, data) => {
    this.SuscripcionTarjetaP2P(datosPagador, data.idPoliza)
  }
  showWarn = (message, severity) => {
    this.growl.show({
      sticky: true,
      severity: severity,
      summary: "Información",
      detail: message,
    });
  };
  handleChange = (selectedOption) => {
    this.setState({ selectedOption });

    this.setState({ formEditado: true });


  };

  handleChangeColores = (selectedOptionColores) => {
    this.setState({ selectedOptionColores });
    this.setState({ hasColorError: false });


  };



  toggleValidating(validate) {
    this.setState({ validate });
  }
  validateForm(e) {
    e.preventDefault();
    this.toggleValidating(true);
    const {
      hasContraseniaActualError,
      hasContraseniaNuevaError,
      hasConfirmacionError,
    } = this.state;

    if (
      !hasContraseniaActualError ||
      !hasContraseniaNuevaError ||
      !hasConfirmacionError
    ) {
      this.handleOnClick();
    }
  }


  onSelect = (value) => {

    if (value) {
      this.setState({
        planSeleccionado: value,
        formEditado: true,
      });
    }


  };


  /**
   * 
   * @param {*} list lista inicial
   * @returns  Lista formateada para utilizar en Select1
   */
  listSlct1Cuotas = (list, planSeleccionado) => {

    const numeroMeses = planSeleccionado.vigenciaMeses.split(' ')[0];


    const formatList = []

    list.forEach(element => {

      if (element <= numeroMeses) {
        formatList.push({
          value: element,
          label: element == 1 ? '1 mes (Pago corriente)' : element + ' meses'
        })
      }

    });


    // return
    return formatList
  }

  onEditarPlaca = (e) => {
    this.props.history.push({
      pathname: "/cotizacion",
      search: `?accion=editarPlaca&editarPlaca=true`

    });
  }


  onClickAtras = () => {

    this.props.history.push({
      pathname: "/listado-renovaciones"
    });

  }


  onClickContinuar = async (e) => {


    if (
      this.state.valorAsegurado != "" &&
      this.state.valorAsegurado != undefined &&
      this.state.valorAsegurado > 0

    ) {

      this.setState({
        isLoading: true,
      })




      const data = await apiGet(`${urlGuardarRenovaciones}${this.state.dataRenovacion.numeroPolizaEmision}`)

      console.log('fata', data)

      if (data.transaccion) {



        this.props.history.push({
          pathname: "/resumen-cotizacion",
          search: `?id=${data.data.idCarrito}&paso=resumen&codigoProductoEspecial=comparador&esRenovacion=true`

        });





      } else {
        if (data.errorDescripcion && data.errorDescripcion != '') {
          this.setState({
            tieneError: true,
            mensajeError: data.errorDescripcion
          })
        }
      }

      this.setState({
        isLoading: false,
      })

    }




  }

  irAFormularioVinculacion = async (idCarrito) => {
    this.props.history.push({
      pathname: "/forma-pago",
      search: `?id=${idCarrito}`,
    });
  }

  // suscribir tarjeta p2p
  async SuscripcionTarjetaP2P(pagador, idPoliza) {


    const nombre = pagador.cliNombre1;
    const apellido = pagador.cliApellido1;
    const email = pagador.cliEmail;
    const identificacion = pagador.cliIdentificacion;
    const tipoDocumento = pagador.cliCodigoTipoDocumento === 'CÉDULA' ? 'CI' : (pagador.cliCodigoTipoDocumento === 'RUC' ? 'RUC' : 'PAS');
    const celular = pagador.cliCelular;
    let cliIp = '';
    await publicIp.v4().then(
      ip => cliIp = ip
    );

    // body post
    const body = tramaSuscripcionTarjetaP2P({
      idPoliza, nombre, apellido, email, identificacion, tipoDocumento, celular, cliIp
    });



    // consultar servicio para redireccion
    await this.props.suscripcionP2P(body);
    window.location.href = this.props.placetoPay.suscripcionTarjetaP2PResponse.traUrl;

  }


  onClickActualizar = async (e) => {

    if (
      this.state.valorAsegurado != "" &&
      this.state.valorAsegurado != undefined &&
      this.state.valorAsegurado > 0 &&
      this.state.hasValorAccesoriosError == false

    ) {

      let datosAccesorios = {
        "datosAccesorios": {
          "accesorios": this.state.selectedOption,
          "valorAccesorios": this.state.valorAccesorios
        }
      }

      await this.props.listarRecompra(this.props.idPoliza, this.state.planSeleccionado.codigo, this.state.valorAsegurado, datosAccesorios)

      this.handleChangeBanco(this.state.bancoSeleccionado)

      this.setState({
        formEditado: false,
      });

    }

  }

  obtenerNombreODenominacion = (datos) => {
    if (!datos) return "";

    if (datos.reIdentificacion && datos.reIdentificacion.length === 13 && datos.reIdentificacion.endsWith("001")) {
        return datos.reRazonSocial ||  (datos.reNombre1 ? datos.reNombre1 + " " : "") +
        (datos.reNombre2 ? datos.reNombre2 + " " : "") +
        (datos.reApellido1 ? datos.reApellido1 + " " : "") +
        (datos.reApellido2 ? datos.reApellido2 : "");
    }

    return (
        (datos.reNombre1 ? datos.reNombre1 + " " : "") +
        (datos.reNombre2 ? datos.reNombre2 + " " : "") +
        (datos.reApellido1 ? datos.reApellido1 + " " : "") +
        (datos.reApellido2 ? datos.reApellido2 : "")
    ).trim();
};


  render() {
    const {
      validate,
      placa,
      rastreo,
      utilizarMismaTarjeta,
      formEditado,
      valorAsegurado,
      deducibleSelected,
      arrayRc,
      rcSelected,
      verDeducibles,
      verRc,
      dataRenovacion,
      allDataRenovacion
    } = this.state;

    console.log('dataRenovacionVer', allDataRenovacion)



    const { datosRecompra, datosBancos, } = this.props;





    return (
      <LoadingScreen

        loading={this.state.isLoading}

        bgColor="#f1f1f1"
        spinnerColor="#001871"
        textColor="#676767"
        logoSrc={logo}
        text={this.state.isLoading ? "Guardando información..." : "Obteniendo información..."}
      >

        {
          dataRenovacion && dataRenovacion && allDataRenovacion ?
            <Row>
              <Col
                lg={8}
                md={12}
                sm={12}
                xs={12}
                className="detalle-cotizacion-box"
              >
                <Card className="flex-row">
                  <CardBody>
                    <h4 style={{ fontWeight: "bold" }}>Datos del Asegurado</h4>
                    <p />

                    {
                      allDataRenovacion && allDataRenovacion.reDatosAsegurado && allDataRenovacion.reDatosAsegurado.reIdentificacion ?

                        <React.Fragment>

                          <Row>
                            <Col lg={6} md={6} sm={6} xs={12}>
                              <h5 style={{ fontWeight: "bold" }}>Identificación</h5>
                            </Col>
                            <Col lg={6} md={6} sm={6} xs={12}>
                              <Textbox
                                classNameInput="input-type-label form-control"
                                value={allDataRenovacion.reDatosAsegurado.reIdentificacion}
                              />
                            </Col>
                            <Col lg={6} md={6} sm={6} xs={12}>
                              <h5 style={{ fontWeight: "bold" }}>Nombre Completo</h5>
                            </Col>
                            <Col lg={6} md={6} sm={6} xs={12}>
                              <Textbox
                                classNameInput="input-type-label form-control"
                                // value={`${dataRenovacion.nombreContratante} `}
                                value={this.obtenerNombreODenominacion(allDataRenovacion ? allDataRenovacion.reDatosAsegurado : null)}
                              />
                            </Col>
                          </Row>
                          <Row>

                            {
                              allDataRenovacion.reDatosAsegurado.reEmail &&
                              allDataRenovacion.reDatosAsegurado.reEmail != '' &&

                              <React.Fragment>

                                <Col lg={6} md={6} sm={6} xs={12}>
                                  <h5 style={{ fontWeight: "bold" }}>Email</h5>
                                </Col>
                                <Col lg={6} md={6} sm={6} xs={12}>
                                  <Textbox
                                    classNameInput="input-type-label form-control"
                                    value={allDataRenovacion.reDatosAsegurado.reEmail}
                                  />
                                </Col>
                              </React.Fragment>


                            }

                            {
                              allDataRenovacion.reDatosAsegurado.reDireccion &&
                              allDataRenovacion.reDatosAsegurado.reDireccion != '' &&

                              <React.Fragment>


                                <Col lg={6} md={6} sm={6} xs={12}>
                                  <h5 style={{ fontWeight: "bold" }}>Dirección</h5>
                                </Col>
                                <Col lg={6} md={6} sm={6} xs={12}>
                                  <Textbox
                                    classNameInput="input-type-label form-control"
                                    value={allDataRenovacion.reDatosAsegurado.reDireccion}
                                  />
                                </Col>
                              </React.Fragment>


                            }



                          </Row>

                        </React.Fragment> :

                        <React.Fragment>

                          <Row>
                            <Col lg={6} md={6} sm={6} xs={12}>
                              <h5 style={{ fontWeight: "bold" }}>Identificación</h5>
                            </Col>
                            <Col lg={6} md={6} sm={6} xs={12}>
                              <Textbox
                                classNameInput="input-type-label form-control"
                                value={allDataRenovacion.reDatosAsegurado.reCodigoCliente}
                              />
                            </Col>
                            <Col lg={6} md={6} sm={6} xs={12}>
                              <h5 style={{ fontWeight: "bold" }}>Nombre Completo</h5>
                            </Col>
                            <Col lg={6} md={6} sm={6} xs={12}>
                              <Textbox
                                classNameInput="input-type-label form-control"
                                value={`${allDataRenovacion.reDatosAsegurado.reNombre1} ${allDataRenovacion.reDatosAsegurado.reApellido1 ? allDataRenovacion.reDatosAsegurado.reApellido1 : ''}`}
                                // value={dataRenovacion.nombreContratante}
                              />
                            </Col>
                          </Row>

                        </React.Fragment>


                    }

                    {/* Más campos como dirección, teléfono, etc. */}
                  </CardBody>
                </Card>



                {
                  (allDataRenovacion && allDataRenovacion.reDatosProducto && allDataRenovacion.reDatosProducto.reDatosVehiculo && allDataRenovacion.reDatosProducto.reDatosVehiculo[0]) &&

                  allDataRenovacion.reDatosProducto.reDatosVehiculo.map((vehiculo, index) => {

                    console.log('vehiculo', vehiculo)
                    return (

                      <Card className="flex-row">
                        <CardBody>
                          <h4 style={{ fontWeight: "bold" }}>Datos del Vehículo {index + 1}</h4>
                          <p />
                          <Row>
                            <Col lg={6} md={6} sm={6} xs={12}>
                              <h5 style={{ fontWeight: "bold" }}>Placa</h5>
                            </Col>
                            <Col lg={6} md={6} sm={6} xs={12}>
                              <Textbox
                                classNameInput="input-type-label form-control"
                                value={vehiculo.rePlaca}
                              />
                            </Col>
                            <Col lg={6} md={6} sm={6} xs={12}>
                              <h5 style={{ fontWeight: "bold" }}>Marca</h5>
                            </Col>
                            <Col lg={6} md={6} sm={6} xs={12}>
                              <Textbox
                                classNameInput="input-type-label form-control"
                                value={vehiculo.reMarca}
                              />
                            </Col>
                          </Row>
                          <Row>
                            <Col lg={6} md={6} sm={6} xs={12}>
                              <h5 style={{ fontWeight: "bold" }}>Modelo</h5>
                            </Col>
                            <Col lg={6} md={6} sm={6} xs={12}>
                              <Textbox
                                classNameInput="input-type-label form-control"
                                value={vehiculo.reModelo}
                              />
                            </Col>
                          </Row>

                          <Row>
                            <Col lg={6} md={6} sm={6} xs={12}>
                              <h5 style={{ fontWeight: "bold" }}>Color</h5>
                            </Col>
                            <Col lg={6} md={6} sm={6} xs={12}>
                              <Textbox
                                classNameInput="input-type-label form-control"
                                value={vehiculo.reColorTxt}
                              />
                            </Col>
                          </Row>

                          <Row>
                            <Col lg={6} md={6} sm={6} xs={12}>
                              <h5 style={{ fontWeight: "bold" }}>Motor</h5>
                            </Col>
                            <Col lg={6} md={6} sm={6} xs={12}>
                              <Textbox
                                classNameInput="input-type-label form-control"
                                value={vehiculo.reMotor}
                              />
                            </Col>
                          </Row>

                          <Row>
                            <Col lg={6} md={6} sm={6} xs={12}>
                              <h5 style={{ fontWeight: "bold" }}>Chasis</h5>
                            </Col>
                            <Col lg={6} md={6} sm={6} xs={12}>
                              <Textbox
                                classNameInput="input-type-label form-control"
                                value={vehiculo.reChasis}
                              />
                            </Col>
                          </Row>

                          <Row>
                            <Col lg={6} md={6} sm={6} xs={12}>
                              <h5 style={{ fontWeight: "bold" }}>Año</h5>
                            </Col>
                            <Col lg={6} md={6} sm={6} xs={12}>
                              <Textbox
                                classNameInput="input-type-label form-control"
                                value={vehiculo.reAño}
                              />
                            </Col>
                          </Row>


                          {
                            vehiculo.reProductoOriginal &&
                            <Row>
                              <Col lg={6} md={6} sm={6} xs={12}>
                                <h5 style={{ fontWeight: "bold" }}>Producto actual</h5>
                              </Col>
                              <Col lg={6} md={6} sm={6} xs={12}>
                                <Textbox
                                  classNameInput="input-type-label form-control"
                                  value={vehiculo.reProductoOriginal}
                                />
                              </Col>
                            </Row>


                          }

                          {
                            vehiculo.reProducto &&
                            <Row>
                              <Col lg={6} md={6} sm={6} xs={12}>
                                <h5 style={{ fontWeight: "bold" }}>Producto a renovar</h5>
                              </Col>
                              <Col lg={6} md={6} sm={6} xs={12}>
                                <Textbox
                                  classNameInput="input-type-label form-control"
                                  value={vehiculo.reProducto}
                                />
                              </Col>
                            </Row>

                          }




                          <Row>
                            <Col lg={6} md={6} sm={6} xs={12}>
                              <h5 style={{ fontWeight: "bold" }}>Suma asegurada anterior</h5>
                            </Col>
                            <Col lg={6} md={6} sm={6} xs={12}>
                              <Textbox
                                classNameInput="input-type-label form-control"
                                value={`$${formatearNumero(vehiculo.reValorAsegurado)}`}
                              />
                            </Col>
                          </Row>
                          {/* Más campos como año, color, cilindraje, etc. */}
                        </CardBody>
                      </Card>

                    )
                  })
                }



                {(allDataRenovacion && allDataRenovacion.reDatosConductor) &&
                  <Card className="flex-row">
                    <CardBody>
                      <h4 style={{ fontWeight: "bold" }}>Datos del Conductor</h4>
                      <p />
                      <Row>
                        <Col lg={6} md={6} sm={6} xs={12}>
                          <h5 style={{ fontWeight: "bold" }}>Identificación</h5>
                        </Col>
                        <Col lg={6} md={6} sm={6} xs={12}>
                          <Textbox
                            classNameInput="input-type-label form-control"
                            value={allDataRenovacion.reDatosConductor.reIdentificacion}
                          />
                        </Col>
                        <Col lg={6} md={6} sm={6} xs={12}>
                          <h5 style={{ fontWeight: "bold" }}>Nombre Completo</h5>
                        </Col>
                        <Col lg={6} md={6} sm={6} xs={12}>
                          <Textbox
                            classNameInput="input-type-label form-control"
                            value={`${allDataRenovacion.reDatosConductor.reNombre1} ${allDataRenovacion.reDatosConductor.reApellido1}`}
                          />
                        </Col>

                        <Col lg={6} md={6} sm={6} xs={12}>
                          <h5 style={{ fontWeight: "bold" }}>Dirección</h5>
                        </Col>
                        <Col lg={6} md={6} sm={6} xs={12}>
                          <Textbox
                            classNameInput="input-type-label form-control"
                            value={allDataRenovacion.reDatosConductor.reDireccion}
                          />
                        </Col>


                      </Row>
                      {/* Más campos como teléfono, dirección, etc. */}
                    </CardBody>
                  </Card>

                }

                <Card className="flex-row">
                  <CardBody>
                    <h4 style={{ fontWeight: "bold" }}>Datos del Producto</h4>
                    <p />
                    <Row>
                      <Col lg={6} md={6} sm={6} xs={12}>
                        <h5 style={{ fontWeight: "bold" }}>Producto</h5>
                      </Col>
                      <Col lg={6} md={6} sm={6} xs={12}>
                        <Textbox
                          classNameInput="input-type-label form-control"
                          value={dataRenovacion.polDescripcionSeguroVer}
                        />
                      </Col>
                    </Row>


                    {/* <Row>
                      <Col lg={6} md={6} sm={6} xs={12}>
                        <h5 style={{ fontWeight: "bold" }}>Estado Formulario de vinculación</h5>
                      </Col>
                      <Col lg={6} md={6} sm={6} xs={12}>

                        <Textbox
                          classNameInput="input-type-label form-control"
                          value={dataRenovacion.estadoFormVinculacion}
                        />

                      </Col>
                    </Row> */}
                    {/* Más campos como deducible, plan seleccionado, etc. */}
                  </CardBody>
                </Card>



                <Button
                  className={
                    "btn btn-primary"
                  }
                  onClick={this.onClickAtras}
                  disabled={false}
                  style={{ display: "block", margin: "0", marginBottom: 20 }}>
                  <i
                    className='fa fa-chevron-circle-left'
                    aria-hidden='true'
                  />{" "}
                  {"ATRÁS"}
                </Button>






              </Col>

              <Col
                lg={4}
                md={12}
                sm={12}
                xs={12}
                className="detalle-impuestos-box"
              >
                <Growl ref={(el) => (this.growl = el)} style={{ top: "100px" }} />
                <Modal
                  isOpen={this.state.openModal && this.state.datosPagador && this.state.idPoliza && this.state.idCarrito}
                  toggle={() => this.openModal(false)}
                >
                  <ModalHeader toggle={() => this.openModal(false)}>
                    Seleccione una opción
                  </ModalHeader>
                  <ModalBody>
                    <div className="text-center">

                      <Button
                        onClick={(evt) => {


                          this.SuscripcionTarjetaP2P(this.state.datosPagador, this.state.idPoliza)
                          this.openModal(false)
                          this.setState({ loadign: true });
                        }
                        }
                      >
                        <i
                          className="fa fa-credit-card"
                          aria-hidden="true"
                        />{" "}
                        Pago con tarjeta
                      </Button>

                      <Button
                        style={{ marginLeft: 10 }}
                        onClick={async (evt) => {

                          this.setState({ loadign: true, openModal: false })

                          var url = `${urlGenerarPago}${this.state.idPoliza}`;

                          await fetch(url, {
                            method: "get",
                            headers: {
                              Accept: "application/json",
                            },
                          })
                            .then((response) => response.json())
                            .then((data) => {

                              this.setState({ loadign: false })



                              if (data.transaccion) {
                                this.showWarn(data.alerta, 'info')

                                setTimeout(() => {
                                  this.irAFormularioVinculacion(this.state.idCarrito)

                                }, 2000);

                              } else {
                                this.showWarn(data.alerta, 'warn')

                              }



                            })
                            .catch((response) => {
                              console.log('error')
                              this.setState({ loadign: false, errorEnvio: true })
                            });



                        }


                        }
                      >
                        <i
                          className="fa fa-envelope"
                          aria-hidden="true"
                        />{" "}
                        {'Enviar correo al cliente'}
                      </Button>

                    </div>
                  </ModalBody>
                  <ModalFooter>
                    <Button color="secondary" onClick={() => this.openModal(false)}>
                      Cerrar
                    </Button>
                  </ModalFooter>
                </Modal>
                <ValoresRenovacion
                  key={1}
                  setLoading={(value => {
                    this.setState({
                      isLoading: value
                    })
                  })}
                  formEditado={formEditado}
                  producto={dataRenovacion.polDescripcionSeguroVer}
                  dataRenovacion={dataRenovacion}
                  tieneError={this.state.tieneError}
                  mensajeError={this.state.mensajeError}
                  recompra={true}
                  paso={"datos-cotizacion"}
                  metodo={this.onClick}
                  placa={placa}
                  urlPdf={null}
                  completo={this.state.completo}
                  planes={[]}
                  totales={null}
                  email={this.state.email}
                  metodoEnviar={(event) => { }}
                  setEmail={(email) => { this.setState({ email: email }) }}
                  planSeleccionado={this.state.planSeleccionado}
                  codigoProductoEspecial={
                    this.state.codigoProductoEspecial != null ? true : false
                  }
                  openModal={() => this.openModal(true)}
                  codeProductoEspecial={this.state.codigoProductoEspecial}
                  onContinuar={this.onClickContinuar}
                  onActualizar={this.onClickActualizar}
                  onSelect={this.onSelect}
                  disabled={this.state.errorSumaAsegurada !== '' ? true : false}
                />
              </Col>
            </Row>


            : null
        }








      </LoadingScreen>
    );
  }
}

/**
 * 
 * @param {*} list lista inicial
 * @returns  Lista formateada para utilizar en Select1
 */
const listSlct1 = (list) => {
  console.log('list', list)
  const formatList = []
  for (const idx in list) {

    formatList.push({
      value: list[idx]['id'],
      label: list[idx]['nombre']
    })
  }

  // return
  return formatList
}



const mapStateToProps = (state) => ({
  catalogoCotizacion: state.catalogosCotizacion,
  dataProductoCarrito: state.dataProductoCarrito,
  datosCotizacion: state.datosCotizacion,
  datosUsuarios: state.datosUsuarios.dataUsuario,
  datosSucursales: state.datosSucursales,
  datosCoberturas: state.catalogosCotizacion.coberturas,
  datosAmparos: state.catalogosCotizacion.amparosAdicionales,
  deduciblesRolesDatos: state.deduciblesRolesDatos,
  limitesVehiculos: state.dataParametros,
  placetoPay: state.rPlaceToPay,
  formularioVinculacion: state.rFormularioVinculacion,
  datosRenovaciones: state.dataRenovaciones,
  datosUsuario: state.datosUsuarios.dataUsuario,
});

const mapDispatchToProps = (dispatch) => {
  return {
    consultarCedula: (cedula, esAsegurado) => dispatch(consultarCedulaFetch(cedula, esAsegurado)),
    setDatosPlaca: (datos) => dispatch(setConsultaPlaca(datos)),
    descargarCotizacion: (datos) => dispatch(FetchDescargarCotizacionAbierto(datos)),
    modificarCarrito: (datos) => dispatch(FetchModificarCarrito(datos)),
    setDatosPersona: (datos) => dispatch(setDatosPersona(datos)),
    fetchGuardarDatosAdiconalesCarrito: (datos, array) =>
      dispatch(FetchGuardarDatosAdiconalesCarrito(datos, array)),
    listarCoberturas: (territorio) => dispatch(coberturasFetch(territorio)),
    listarAmparosAdicionales: (territorio, codEspecial) =>
      dispatch(AmparosAdicionalesFetch(territorio, codEspecial)),
    actualizarTotalesCabecera: (param) =>
      dispatch(FetchTotalesCabeceraCotizadores(param)),
    listarRecompra: (idPoliza, plan, suma, datosAccesorios) => dispatch(FetchDataRecompraPaquete(idPoliza, plan, suma, datosAccesorios)),
    suscripcionP2P: (datos) => dispatch(suscripcionExternaTarjetaP2P(datos)),
    consultarFv: (data) => dispatch(consultarUsuarioFV(data)),
    listadoDeRenovaciones: (param, ambiente, id, rango, filtro) => dispatch(FetchListadoRenovaciones(param, ambiente, id, rango, filtro)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Renovacion)
);
